import { render } from "./UENutritionListView.vue?vue&type=template&id=70e0dd06&scoped=true"
import script from "./UENutritionListView.vue?vue&type=script&lang=js"
export * from "./UENutritionListView.vue?vue&type=script&lang=js"

import "./UENutritionListView.vue?vue&type=style&index=0&id=70e0dd06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e0dd06"]])

export default __exports__